import constants from "../../../constants";
import { useContext, useState } from "react";
import AlertContext from "../../../context/AlertContext";
import MockTestLibraryHooks from "./MockTestLibraryHooks";
import StudentTestPageHooks from "../../StudentTestPage/StudentTestPageHooks";
import { getDataFromStorage } from "../../../util";

export default function MockTestResultsHooks() {
  const Alert = useContext(AlertContext);

  const { viewTest } = StudentTestPageHooks();
  const { handleCodingInfo } = MockTestLibraryHooks();

  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (rowId) => {
    console.log(rowId);

    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  const findFileType = (key, isVideoQn, aiMode) => {
    const typeRefs = {
      2: "MCQ",
      1: "Descriptive",
      12: "Coding Snippet",
      3: aiMode === 1 ? "AI Interview" : isVideoQn === 1 ? "Video Assesment" : "Descriptive",
      5: "Coding Challenge",
    };
    return typeRefs[key] || "Test Series";
  };

  const getSubmittedDate = (date) => {
    date = new Date(date);

    return (
      ((date.getDate() + 1).toString().length === 1
        ? "0" + date.getDate()
        : date.getDate()) +
      "/" +
      ((date.getMonth() + 1).toString().length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "/" +
      date.getFullYear()
    );
  };

  const handleView = (test) => {
    if (test.lp) {
      Alert.setLpId(test.id);
      localStorage.setItem("mockLp", true);
      sessionStorage.setItem("lpId", test.id);
      sessionStorage.setItem("lmpid", test.lmpid);
      Alert.navigate("home");
    } else {
      let testData = {
        mockuse: true,
        testid: test.id,
        lpconfigid: 1567,
        lmpid: test.lmpid,
        lmtid: test.lmtid,
        withAI: test.withAI,
        testname: test.name,
        testmode: test.mode,
        status: test.status,
        libtype: test.libtype,
        testtype: test.libtype,
        viewtest: test.viewtest,
        autoeval: test.autoeval === 1,
        proctored: constants.PROCTORING_MODE.TAB_CAM,
        learnerid: test.learnerid ? test.learnerid : getDataFromStorage("learnerid"),
        configdata: {
          marks: test.marks,
          duration: test.testduration,
          questionscount: test.questionscount,
        },
        scope:test.scope,
      };

      Alert.setTestData(testData);
      Alert.setStatus(constants.PROGRESS_STATUS.EVALUATED);
      Alert.setLpId(parseInt(sessionStorage.getItem("lpId")));
      Alert.setIsTakeTest(false);

      if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
        console.log("testData 2 :",testData);
        handleCodingInfo(testData);
      } else {
        viewTest(testData);
      }
    }
  };

  return {
    handleView,
    toggleRow,
    findFileType,
    getSubmittedDate,
    expandedRow,
    setExpandedRow,
  };
}
